import { render, staticRenderFns } from "./RoomFormEdit.vue?vue&type=template&id=4bf96f01&"
import script from "./RoomFormEdit.vue?vue&type=script&lang=js&"
export * from "./RoomFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports